// WO-2929 AC-03: renders the page only when the person's app memberships allow that area. A GenServ-only person asking for a Charlie area (or anyone whose GenServ access
// has ended asking for GenServ) sees a short refusal with a way back instead of the page. People with no membership rows are untouched (pre-WO-2929 behaviour).
import React from 'react';
import { routeVerdict } from '../lib/appIdentity';

export default function AppRouteGate({ memberships, activeKey, isGenservKey, onNavigate, children }) {
  const verdict = routeVerdict(memberships, activeKey, isGenservKey);
  if (verdict.allowed) return children;
  return (
    <div role="alert" data-testid="app-route-refused" style={{ padding: 32, display: 'grid', gap: 12, maxWidth: 480 }}>
      <div style={{ fontSize: 18, fontWeight: 700 }}>{verdict.reason}</div>
      {verdict.home && onNavigate && <button type="button" onClick={() => onNavigate(verdict.home)} style={{ minHeight: 44, justifySelf: 'start', padding: '0 16px' }}>Go to GenServ</button>}
    </div>
  );
}
